document.addEventListener("DOMContentLoaded", function () {
  // --- ÓRBITA PANTALLA 1 ---
  function initOrbit() {
    const innerItems = document.querySelectorAll('.inner-item');
    const outerItems = document.querySelectorAll('.outer-item');
    const isMobile = window.innerWidth < 768;
    const innerRadius = isMobile ? 210 : 380;
    const outerRadius = isMobile ? 340 : 620;

    positionCircleItems(innerItems, innerRadius, isMobile);
    positionCircleItems(outerItems, outerRadius, isMobile);

    if (typeof gsap !== 'undefined') {
      gsap.to('#wt-inner-ring', { rotation: 360, duration: 90, repeat: -1, ease: 'none' });
      gsap.to('.inner-item .wt-product-circle', { rotation: -360, duration: 90, repeat: -1, ease: 'none' });
      gsap.to('#wt-outer-ring', { rotation: -360, duration: 120, repeat: -1, ease: 'none' });
      gsap.to('.outer-item .wt-product-circle', { rotation: 360, duration: 120, repeat: -1, ease: 'none' });
    }
  }

  function positionCircleItems(items, radius, isMobile) {
    const total = items.length;
    if (total === 0) return;
    const angleStep = (2 * Math.PI) / total;
    const offset = isMobile ? 45 : 75;

    items.forEach((item, index) => {
      const angle = index * angleStep;
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius;
      item.style.left = `calc(50% + ${x}px - ${offset}px)`;
      item.style.top = `calc(50% + ${y}px - ${offset}px)`;
    });
  }

  initOrbit();

  // --- ESTADO GLOBAL ---
  let selectedColor = 'all';
  let selectedType = 'all';
  let selectedSize = 'all';

  const screen1 = document.getElementById('wt-screen-1');
  const screen2 = document.getElementById('wt-screen-2');
  const screen3 = document.getElementById('wt-screen-3');
  const screen4 = document.getElementById('wt-screen-4');
  const screen5 = document.getElementById('wt-screen-5');

  const startBtn = document.getElementById('wt-gf-start-btn');
  const backBtn2 = document.getElementById('wt-gf-back-btn');
  const backBtn3 = document.getElementById('wt-gf-back-btn-step3');
  const backBtn4 = document.getElementById('wt-gf-back-btn-step4');
  const backBtn5 = document.getElementById('wt-gf-back-btn-step5');

  const swatches = document.querySelectorAll('.wt-swatch');
  const typeBtns = document.querySelectorAll('.wt-gf-type-btn');
  const sizeBtns = document.querySelectorAll('.wt-gf-size-btn');
  
  const gridItemsScreen2 = screen2 ? screen2.querySelectorAll('.wt-gf-grid-item') : [];
  const gridItemsScreen3 = screen3 ? screen3.querySelectorAll('.wt-gf-grid-item') : [];
  const gridItemsScreen4 = screen4 ? screen4.querySelectorAll('.wt-gf-grid-item') : [];
  const gridItemsScreen5 = screen5 ? screen5.querySelectorAll('.wt-gf-result-item') : [];

  // --- MOTOR DE TRANSICIÓN CON OPACIDAD ---
  function transitionBetweenScreens(fromScreen, toScreen, callback) {
    if (!fromScreen || !toScreen) return;

    fromScreen.style.opacity = '0';

    setTimeout(() => {
      fromScreen.style.visibility = 'hidden';
      fromScreen.classList.remove('is-active');

      if (typeof callback === 'function') callback();

      toScreen.style.visibility = 'visible';
      toScreen.classList.add('is-active');
      void toScreen.offsetWidth; 
      toScreen.style.opacity = '1';
    }, 500);
  }

  // --- NAVEGACIÓN PASO 1 -> PANTALLA 2 ---
  if (startBtn) {
    startBtn.addEventListener('click', function () {
      transitionBetweenScreens(screen1, screen2, function() {
        applyFiltersScreen2();
      });
    });
  }

  // --- NAVEGACIÓN PANTALLA 2 -> PANTALLA 3 (Color) ---
  swatches.forEach(swatch => {
    swatch.addEventListener('click', function () {
      swatches.forEach(s => s.classList.remove('active'));
      this.classList.add('active');

      selectedColor = this.getAttribute('data-color') || 'all';

      transitionBetweenScreens(screen2, screen3, function () {
        applyFiltersScreen3();
      });
    });
  });

  // --- NAVEGACIÓN PANTALLA 3 -> PANTALLA 4 (Tipo) ---
  typeBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      typeBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      selectedType = this.getAttribute('data-type') || 'all';

      transitionBetweenScreens(screen3, screen4, function () {
        applyFiltersScreen4();
      });
    });
  });

  // --- NAVEGACIÓN PANTALLA 4 -> PANTALLA 5 (Tamaño / Vista Final) ---
  sizeBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      sizeBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      selectedSize = this.getAttribute('data-size') || 'all';

      // Salto con opacidad hacia la Pantalla 5 de resultados
      transitionBetweenScreens(screen4, screen5, function () {
        applyFiltersScreen5();
      });
    });
  });

  // --- BOTONES ATRÁS ---
  if (backBtn2) {
    backBtn2.addEventListener('click', function () {
      transitionBetweenScreens(screen2, screen1);
    });
  }

  if (backBtn3) {
    backBtn3.addEventListener('click', function () {
      transitionBetweenScreens(screen3, screen2);
    });
  }

  if (backBtn4) {
    backBtn4.addEventListener('click', function () {
      transitionBetweenScreens(screen4, screen3);
    });
  }

  if (backBtn5) {
    backBtn5.addEventListener('click', function () {
      transitionBetweenScreens(screen5, screen4);
    });
  }

  // --- FILTROS POR PANTALLA ---
  function applyFiltersScreen2() {
    let visibleCount = 0;
    gridItemsScreen2.forEach(item => {
      const dial = item.getAttribute('data-dial') || '';
      const pulso = item.getAttribute('data-pulso') || '';
      let match = (selectedColor === 'all') || new RegExp(selectedColor, 'i').test(dial) || new RegExp(selectedColor, 'i').test(pulso);

      if (match) {
        item.classList.remove('is-hidden');
        visibleCount++;
      } else {
        item.classList.add('is-hidden');
      }
    });
    const countEl = document.getElementById('wt-gf-count-text');
    if (countEl) countEl.textContent = `${Math.ceil(visibleCount / 2)} PRODUCTOS`;
  }

  function applyFiltersScreen3() {
    let visibleCount = 0;
    gridItemsScreen3.forEach(item => {
      const dial = item.getAttribute('data-dial') || '';
      const pulso = item.getAttribute('data-pulso') || '';
      const itemType = item.getAttribute('data-type') || 'reloj';

      let colorMatch = (selectedColor === 'all') || new RegExp(selectedColor, 'i').test(dial) || new RegExp(selectedColor, 'i').test(pulso);
      let typeMatch = (selectedType === 'all') || (itemType === selectedType);

      if (colorMatch && typeMatch) {
        item.classList.remove('is-hidden');
        visibleCount++;
      } else {
        item.classList.add('is-hidden');
      }
    });
    const countEl = document.getElementById('wt-gf-count-text-step3');
    if (countEl) countEl.textContent = `${Math.ceil(visibleCount / 2)} PRODUCTOS`;
  }

  function applyFiltersScreen4() {
    let visibleCount = 0;
    gridItemsScreen4.forEach(item => {
      const dial = item.getAttribute('data-dial') || '';
      const pulso = item.getAttribute('data-pulso') || '';
      const itemType = item.getAttribute('data-type') || 'reloj';
      const itemSize = item.getAttribute('data-size') || 'discreto';

      let colorMatch = (selectedColor === 'all') || new RegExp(selectedColor, 'i').test(dial) || new RegExp(selectedColor, 'i').test(pulso);
      let typeMatch = (selectedType === 'all') || (itemType === selectedType);
      let sizeMatch = (selectedSize === 'all') || (itemSize === selectedSize);

      if (colorMatch && typeMatch && sizeMatch) {
        item.classList.remove('is-hidden');
        visibleCount++;
      } else {
        item.classList.add('is-hidden');
      }
    });
    const countEl = document.getElementById('wt-gf-count-text-step4');
    if (countEl) countEl.textContent = `${Math.ceil(visibleCount / 2)} PRODUCTOS`;
  }

  function applyFiltersScreen5() {
    gridItemsScreen5.forEach(item => {
      const dial = item.getAttribute('data-dial') || '';
      const pulso = item.getAttribute('data-pulso') || '';
      const itemType = item.getAttribute('data-type') || 'reloj';
      const itemSize = item.getAttribute('data-size') || 'discreto';

      let colorMatch = (selectedColor === 'all') || new RegExp(selectedColor, 'i').test(dial) || new RegExp(selectedColor, 'i').test(pulso);
      let typeMatch = (selectedType === 'all') || (itemType === selectedType);
      let sizeMatch = (selectedSize === 'all') || (itemSize === selectedSize);

      if (colorMatch && typeMatch && sizeMatch) {
        item.classList.remove('is-hidden');
      } else {
        item.classList.add('is-hidden');
      }
    });
  }
});